
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell/by-yourself",
      function () {
        return require("private-next-pages/sell/by-yourself/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell/by-yourself"])
      });
    }
  